import { type CollectOrderLine } from "@kanpla/api-contract";

import { type FlexMenu } from "~/api/menus/types";

import { type PreOrderLine } from "../__app.collect.orders.create/orders-create-context";

type ParseVariantChoicesResult = {
  options: CollectOrderLine["options"];
};

/**
 * The picked choices of a line as the order list shows them, in catalog order.
 * Prices live in `pricePreOrderLine`, not here.
 */
export const parseVariantChoices = (
  variants: FlexMenu["variants"],
  preOrderLine: PreOrderLine | undefined
): ParseVariantChoicesResult => {
  if (!preOrderLine) {
    return { options: [] };
  }

  const qtyByChoiceId: Record<string | number, number> = {};
  for (const choice of preOrderLine.choices ?? []) {
    if (!choice?.id) continue;
    qtyByChoiceId[choice.id] = choice.quantity;
  }

  const options: CollectOrderLine["options"] = [];

  for (const variant of variants ?? []) {
    for (const choice of variant.choices ?? []) {
      const qty = qtyByChoiceId[choice.id] ?? 0;
      if (qty <= 0) continue;

      const name = (choice.name ?? "").trim() || "Unknown option";

      options.push({
        id: choice.id,
        name,
        amount: qty,
        allergens: choice.allergens
      });
    }
  }

  return { options };
};
